/**
 * Form submission states
 * @type {Object}
 */
export const FORM_SUBMISSION_STATE = Object.freeze({
    MOUNTING: 'FORM_SUBMISSION_STATE_MOUNTING',
    READY: 'FORM_SUBMISSION_STATE_READY',
    SUBMITTING: 'FORM_SUBMISSION_STATE_SUBMITTING',
    SUCCESS: 'FORM_SUBMISSION_STATE_SUCCESS',
    ERROR: 'FORM_SUBMISSION_STATE_ERROR',
});
